<script setup>
import Header from '@/components/header/Header.vue';
import { useAuthStore } from '@/stores/auth.js';
import { useRoute } from 'vue-router';
import { useNotificationStore } from '@/stores/notification.js';
import { storeToRefs } from 'pinia';
import ToastMessage from '@/components/common/ToastMessage.vue';

// App.vueでストアの値を監視
const store = useNotificationStore();
const { msgState, type, isShow } = storeToRefs(store);

// ログイン後ユーザーの情報を取得
const auth = useAuthStore();
const route = useRoute();
</script>

<template>
  <div class="w-full min-h-screen grid grid-cols-1 grid-rows-[auto_1fr_auto] text-gray-800">
    <!-- ヘッダー -->
    <Header :title="route.meta.title" />

    <main class="w-full px-4 md:px-10 relative">
      <!-- ログイン中 -->
      <div
        class="transition-all duration-500 ease-in-out"
        :class="{
          'opacity-40 blur-sm pointer-events-none': auth.authLoading,
          'opacity-100 blur-0': !auth.authLoading,
        }"
      >
        <ToastMessage :show="isShow" :type="type">
          {{ msgState }}
        </ToastMessage>
        <router-view />
      </div>
      <div v-if="auth.authLoading" class="fixed inset-0 flex items-center justify-center z-50">
        <div
          class="animate-spin h-8 w-8 border-4 border-emerald-500 rounded-full border-t-transparent"
        ></div>
      </div>
    </main>

    <!-- フッター -->
    <footer
      class="bg-emerald-500 h-25 mt-10 grid grid-cols-1 grid-rows-1 items-center justify-center text-center"
    >
      copyright © 2026 Micche Lab All Rights Reserved.
    </footer>
  </div>
</template>
